export default class {
  constructor() {
    this.id = 0;
    this.name = '';
  }

  hydrate(data) {
    if (void 0 !== data.id) this.id = data.id;
    if (void 0 !== data.name) this.name = data.name;
  }
}
